import React from 'react';
import { Box, Typography, Link, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      component="footer"
      sx={{
        width: '100%',
        py: 2,
        px: 3,
        textAlign: 'center',
        borderTop: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : 'rgba(15,23,42,0.08)'}`,
        bgcolor: isDark ? 'rgba(11,15,30,0.6)' : 'rgba(255,255,255,0.6)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        mt: 'auto',
        zIndex: 1,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: isDark ? 'rgba(255,255,255,0.7)' : 'rgba(15,23,42,0.7)',
          fontSize: '0.8rem',
        }}
      >
        © 2026 J2 Learning Pvt. Ltd. All rights reserved.{' '}
        <Link
          component={RouterLink}
          to="/privacy"
          sx={{
            color: isDark ? 'rgba(255,255,255,0.7)' : 'rgba(15,23,42,0.7)',
            textDecoration: 'none',
            fontWeight: 600,
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          Privacy Policy
        </Link>
        {' · '}
        <Link
          component={RouterLink}
          to="/terms"
          sx={{
            color: isDark ? 'rgba(255,255,255,0.7)' : 'rgba(15,23,42,0.7)',
            textDecoration: 'none',
            fontWeight: 600,
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          Terms &amp; Conditions
        </Link>
        {' · '}Powered by{' '}
        <Link
          href="https://hives.cloud"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: isDark ? '#8B5CF6' : '#6366F1',
            textDecoration: 'none',
            fontWeight: 600,
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          Hives.Cloud
        </Link>
      </Typography>
    </Box>
  );
};

export default Footer;
